module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('ul', {
    staticClass: "detail list"
  }, [_c('li', [_vm._m(1), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.rekeningnummer))])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Betaalwijze")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.betaalwijze))])])])])]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('h3', [_c('span', [_vm._v("Betaalgegevens")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Rekeningnummer\n\t\t\t\t\t\t"), _c('a', {
    staticClass: "modal-button",
    attrs: {
      "role": "button",
      "data-toggle": "modal",
      "data-target": "#rekening-modal"
    }
  }, [_vm._v("j")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "rekening-modal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title"
  }, [_vm._v("Rekeningnummer")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._v("\n\t\t        Een IBAN rekeningnummer bestaat uit 18 tekens. Uw IBAN rekeningnummer vindt u op uw bankpas en in uw online bankieren-omgeving. Ook kunt u via de website "), _c('a', {
    attrs: {
      "href": "https://omnummertool.overopiban.nl/",
      "target": "_blank"
    }
  }, [_vm._v("overopiban.nl/")]), _vm._v(" voor een bankrekeningnummer het IBAN rekeningnummer opvragen.\n\t\t      ")]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Ok")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e7a3104c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/components/mijngegevens/betaalgegevens.vue
// module id = 35
// module chunks = 0